export default "__VITE_ASSET__Cd7$rEHh__"